import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CardStatusList from "./List";
import NotFound from "../../NotFound";

import { PageHeader } from "../../Shared";

import { cardStatusActions } from "./actions/cardstatus.actions";

export class CardStatus extends Component {
  componentDidMount() {
    this.getCardStatus();
  }

  getCardStatus = params => {
    if (params) {
      this.props.getCardStatus(params);
    }
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;
    return (
      <div className="CardStatus">
        <Row>
          <Col>
            <PageHeader pageId="cardStatus" pageTitle="Check Card Status" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <CardStatusList
                  match={match}
                  data={response}
                  loadData={this.getCardStatus}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.cardStatus;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardStatus: bindActionCreators(cardStatusActions.getCardStatus, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardStatus);
